const starbucks = ()=> {
    var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'icon';
    link.href = 'https://gw.alicdn.com/tfs/TB1aUVAr.OWBKNjSZKzXXXfWFXa-182-182.png';
    document.getElementsByTagName('head')[0].appendChild(link);
    document.title = '星巴克中国';
}

export default starbucks;


// WEBPACK FOOTER //
// ./src/starbucks.js